import { render, staticRenderFns } from "./creators.vue?vue&type=template&id=5b541e4f&scoped=true&"
import script from "./creators.vue?vue&type=script&lang=js&"
export * from "./creators.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b541e4f",
  null
  
)

export default component.exports